module.exports = __webpack_public_path__ + "static/media/team-4-800x800.942a8bda.jpg";